import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Toaster } from "../components/ui/sonner";
import ProductHero from "../sections/product/ProductHero";
import IntelligentWorkflow from "../sections/product/IntelligentWorkflow";
import HomeVisionShowcase from "../sections/product/HomeVisionShowcase";
import ArchitecturalExploration3D from "../sections/product/ArchitecturalExploration3D";
import DesignToCostEngine from "../sections/product/DesignToCostEngine";
import LiveMaterialsIntelligence from "../sections/product/LiveMaterialsIntelligence";
import QuoteAnalyzerSection from "../sections/product/QuoteAnalyzerSection";
import ConstructionIntelligenceCards from "../sections/product/ConstructionIntelligenceCards";
import TrustSystem from "../sections/product/TrustSystem";
import ProductEcosystem from "../sections/product/ProductEcosystem";
import ProductFinalCta from "../sections/product/ProductFinalCta";

const ProductPage = () => (
    <div className="min-h-screen bg-ink text-white">
        <Navbar />
        <main>
            <ProductHero />
            <IntelligentWorkflow />
            <HomeVisionShowcase />
            <ArchitecturalExploration3D />
            <DesignToCostEngine />
            <LiveMaterialsIntelligence />
            <QuoteAnalyzerSection />
            <ConstructionIntelligenceCards />
            <TrustSystem />
            <ProductEcosystem />
            <ProductFinalCta />
        </main>
        <Footer />
        <Toaster position="bottom-right" />
    </div>
);

export default ProductPage;
